module.exports = __webpack_public_path__ + "img/p-13-1.68ff2382.jpg";